/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useEffect, useState } from 'react';
import { Box, Button, Grid, TextField, Typography } from '@material-ui/core';
import { itemClasses } from '../themes/classes';
import { PopupDialog } from '../Shared';
import AutoFieldLocal from '../Sections/shared/AutoFieldLocal';

export const indexTheList = (list: any) => {
  return list.map((item: any, index: any) => {
    return {
      ...item,
      index,
    };
  });
};

const PopupKaidItem = ({
  open,
  onClose,
  row,
  editAction,
  isRTL,
  words,
  departments,
  employees,
  resourses,
  contracts,
  customers,
  suppliers,
  accounts,
  acustomer,
  asupplier,
  acontract,
  aresourse,
  aemployee,
  adepartment,
  user,
}: any) => {
  const classes = itemClasses();
  const [accvalue, setAccvalue]: any = React.useState(null);

  const [amount, setAmount]: any = React.useState(null);

  const [resovalue, setResovalue] = useState(null);
  const [departvalue, setDepartvalue] = useState(null);
  const [emplvalue, setEmplvalue] = useState(null);
  const [contvalue, setContvalue] = useState(null);
  const [custvalue, setCustvalue] = useState(null);
  const [suppvalue, setSuppvalue] = useState<any>(null);

  const [desc, setDesc]: any = React.useState(null);
  useEffect(() => {
    if (row && row._id) {
      const cusId = row?.customerId;
      const supId = row?.supplierId;
      const depId = row?.departmentId;
      const empId = row?.employeeId;
      const conId = row?.contractId;
      const resId = row?.resourseId;
      const accId = row?.accCode;

      const cust = customers.filter((dep: any) => dep._id === cusId)?.[0];
      setCustvalue(cust);
      const supp = suppliers.filter((dep: any) => dep._id === supId)?.[0];
      setSuppvalue(supp);
      const depart = departments.filter((dep: any) => dep._id === depId)?.[0];
      setDepartvalue(depart);
      const empl = employees.filter((dep: any) => dep._id === empId)?.[0];
      setEmplvalue(empl);
      const reso = resourses.filter((emp: any) => emp._id === resId)?.[0];
      setResovalue(reso);
      const cont = contracts.filter((ts: any) => ts._id === conId)?.[0];
      setContvalue(cont);
      const acc = accounts.filter((ts: any) => ts.code === accId)?.[0];
      setAccvalue(acc);

      setAmount(row?.amount);
      setDesc(row?.desc);
    }
  }, [open]);
  const isDebit = row?.amountDebit > 0 && row?.debit > 0;
  const isCredit = row?.amountCredit > 0 && row?.credit > 0;
  const resetAll = () => {
    setAccvalue(null);
    setAmount(null);
    setResovalue(null);
    setDepartvalue(null);
    setContvalue(null);
    setCustvalue(null);
    setSuppvalue(null);
    setDesc(null);
  };
  const editLocalItem = () => {
    const item = {
      acc: accvalue.code,
      amountCredit: isDebit ? 0 : amount,
      amountDebit: isCredit ? 0 : amount,
      desc,
      supplierId: suppvalue ? suppvalue._id : undefined,
      supplierName: suppvalue ? suppvalue.name : undefined,
      supplierNameAr: suppvalue ? suppvalue.nameAr : undefined,
      customerId: custvalue ? custvalue._id : undefined,
      customerName: custvalue ? custvalue.name : undefined,
      customerNameAr: custvalue ? custvalue.nameAr : undefined,
      departmentId: departvalue ? departvalue._id : undefined,
      departmentName: departvalue ? departvalue.name : undefined,
      departmentNameAr: departvalue ? departvalue.nameAr : undefined,
      employeeId: emplvalue ? emplvalue._id : undefined,
      employeeName: emplvalue ? emplvalue.name : undefined,
      employeeNameAr: emplvalue ? emplvalue.nameAr : undefined,
      resourseId: resovalue ? resovalue._id : undefined,
      resourseName: resovalue ? resovalue.name : undefined,
      resourseNameAr: resovalue ? resovalue.nameAr : undefined,
      contractId: contvalue ? contvalue._id : undefined,
      contractName: contvalue ? contvalue.name : undefined,
      contractNameAr: contvalue ? contvalue.nameAr : undefined,
      userId: user._id,
    };

    const itemdata = {
      ...row,
      ...item,
      index: row?.index,
    };
    editAction(itemdata);
    onFormClose();
  };
  const onFormClose = () => {
    onClose();
    resetAll();
  };

  return (
    <PopupDialog
      open={open}
      onClose={onFormClose}
      maxWidth={'lg'}
      classes={classes}
    >
      <Box
        display="flex"
        style={{
          flex: 1,
          margin: 20,
          direction: isRTL ? 'rtl' : 'ltr',
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h5">
              {isDebit ? (isRTL ? 'مدين' : 'Debit') : isRTL ? 'دائن' : 'Credit'}
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <AutoFieldLocal
              name="account"
              title={isRTL ? 'الحساب' : 'Account'}
              words={words}
              options={accounts}
              value={accvalue}
              setSelectValue={setAccvalue}
              isRTL={isRTL}
              fullwidth
              mb={0}
            ></AutoFieldLocal>
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              name="amount"
              onChange={(e: any) => setAmount(Number(e.target.value))}
              value={amount}
              label={words.amount}
              variant="outlined"
              type="number"
              fullWidth
              onFocus={(e) => e.target.select()}
            />
          </Grid>
          {acustomer && (
            <Grid item xs={12} md={4}>
              <AutoFieldLocal
                name="customer"
                title={isRTL ? 'العميل' : 'Customer'}
                words={words}
                options={customers}
                value={custvalue}
                setSelectValue={setCustvalue}
                isRTL={isRTL}
                fullwidth
                mb={0}
              ></AutoFieldLocal>
            </Grid>
          )}
          {asupplier && (
            <Grid item xs={12} md={4}>
              <AutoFieldLocal
                name="supplier"
                title={isRTL ? 'المورد' : 'Supplier'}
                words={words}
                options={suppliers}
                value={suppvalue}
                setSelectValue={setSuppvalue}
                isRTL={isRTL}
                fullwidth
                mb={0}
              ></AutoFieldLocal>
            </Grid>
          )}
          {acontract && (
            <Grid item xs={12} md={4}>
              <AutoFieldLocal
                name="contract"
                title={isRTL ? 'المشروع' : 'Contract'}
                words={words}
                options={contracts}
                value={contvalue}
                setSelectValue={setContvalue}
                isRTL={isRTL}
                fullwidth
                mb={0}
              ></AutoFieldLocal>
            </Grid>
          )}
          {aresourse && (
            <Grid item xs={12} md={4}>
              <AutoFieldLocal
                name="resourse"
                title={isRTL ? 'مركبة' : 'Resourse'}
                words={words}
                options={resourses}
                value={resovalue}
                setSelectValue={setResovalue}
                isRTL={isRTL}
                fullwidth
                mb={0}
              ></AutoFieldLocal>
            </Grid>
          )}
          {adepartment && (
            <Grid item xs={12} md={4}>
              <AutoFieldLocal
                name="department"
                title={isRTL ? 'القسم' : 'Department'}
                words={words}
                options={departments}
                value={departvalue}
                setSelectValue={setDepartvalue}
                isRTL={isRTL}
                fullwidth
                mb={0}
              ></AutoFieldLocal>
            </Grid>
          )}
          {aemployee && (
            <Grid item xs={12} md={4}>
              <AutoFieldLocal
                name="employee"
                title={isRTL ? 'الموظف' : 'Employee'}
                words={words}
                options={employees}
                value={emplvalue}
                setSelectValue={setEmplvalue}
                isRTL={isRTL}
                fullwidth
                mb={0}
              ></AutoFieldLocal>
            </Grid>
          )}
          <Grid item xs={12} md={8}>
            <TextField
              name="desc"
              onChange={(e: any) => setDesc(e.target.value)}
              value={desc}
              label={words.description}
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              color="primary"
              variant="contained"
              size="small"
              onClick={editLocalItem}
              style={{ width: 100 }}
            >
              {isRTL ? 'حفظ' : 'Save'}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </PopupDialog>
  );
};

export default PopupKaidItem;
